import { get } from 'lodash';
import { TEST_STATUS_DISABLED } from '../../service-tests/ServiceTestAdminConstants';

/**
 * Checks if a test is currently disabled.
 * @param {Object} formData - Test form data
 * @returns {boolean} True if test is disabled
 */
export const isTestDisabled = (formData) => {
    return get(formData, 'status', TEST_STATUS_DISABLED) === TEST_STATUS_DISABLED;
};

export const isBttTestType = (bttTest, showBttAuth) => {
    return bttTest || showBttAuth;
};
